var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _ellipse, _path38, _ellipse2, _ellipse3, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEtc03(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 351,
    height: 234,
    viewBox: "0 0 351 234",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.189453,
    y: 0.617188,
    width: 350,
    height: 233,
    fill: "#448D97"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M208.34 187.121C217.144 191.648 226.346 192.344 232.189 192.344C237.059 192.069 238.84 189.737 238.676 188.725C238.378 186.89 239.024 185.746 236.49 182.994C233.957 180.242 219.195 170.841 212.034 167.745C204.874 164.649 197.045 163.317 194.078 166.254C192.018 168.293 192.42 171.81 194.078 174.96C195.363 177.406 200.828 183.257 208.34 187.121Z",
    fill: "#10201C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M262.487 148.831C273.521 155.657 282.564 155.058 286.445 155.058C293.034 154.856 295.21 151.916 295.059 151.032C294.783 149.427 295.381 148.426 293.034 146.02C290.686 143.614 277.008 135.393 270.374 132.686L270.344 132.674C263.712 129.968 254.813 126.337 252.067 128.902C250.159 130.684 251.016 136.183 252.552 138.938C254.088 141.693 255.918 144.767 262.487 148.831Z",
    fill: "#10201C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M178.195 143.711C176.816 141.844 175.207 137.987 175.207 134.449C175.393 129.576 176.677 132.721 177.65 132.721C178.623 132.721 180.856 136.775 181.504 140.199C182.153 143.623 197.57 160.228 185.006 150.928C181.738 148.508 179.554 145.551 178.214 143.737L178.195 143.711Z",
    fill: "#10201C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M175.703 134.873C176.17 144.849 189.754 154.671 196.487 158.334L196.218 147.032C193.989 145.493 188.865 142.463 182.549 136.837C177.497 132.337 175.88 124.313 175.703 120.863V134.873Z",
    fill: "#B45B5B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M196.507 158.353L196.229 147.309L198.338 145.777L198.453 156.545L196.507 158.353Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M196.843 156.549L196.656 148.901L198.011 147.793L198.115 155.397L196.843 156.549Z",
    fill: "#A3A3A3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M196.843 156.546L196.656 148.898L203.034 152.464L202.136 159.508L196.843 156.546Z",
    fill: "#D07D7D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M290.82 145.156C291.636 146.401 291.797 149.362 290.818 151.645",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M292.568 146.273C292.93 147.041 293.437 149.108 292.568 151.239",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M302.92 139.27C304.086 139.475 306.228 140.612 305.466 143.522",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M304.492 141.156C304.789 141.443 305.294 142.451 304.938 144.187",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M305.326 128.377C305.812 128.139 306.914 127.693 307.437 127.813",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M305.771 126.98C306.009 126.851 306.591 126.593 307.019 126.594",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M301.709 132.915C302.296 132.714 303.622 132.432 304.227 132.915",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M301.854 132.108C302.062 131.921 302.822 131.538 304.195 131.5",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M275.245 112.502C275.254 111.649 275.085 109.68 274.334 108.633",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M275.754 112.358C275.934 111.4 276.084 109.103 275.242 107.578",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M291.822 116.749C291.987 116.014 292.586 114.428 293.665 113.961",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M292.389 117.302C292.602 116.585 293.399 114.956 294.877 114.172",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M242.783 189.12C242.5 189.322 241.644 189.54 240.48 188.797",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M243.56 188.456C243.289 188.603 242.597 188.753 242 188.184",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M249.499 177.09C249.092 177.192 247.884 177.334 246.311 177.09",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M249.599 176.277C249.17 176.39 248.047 176.548 246.988 176.277",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M242.672 183.297C242.927 183.739 243.697 184.667 244.739 184.847",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M242.92 182.781C243.07 183.141 243.607 183.891 244.56 184.017",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M223.564 141.727C218.849 141.228 214.944 144.015 213.58 145.471C217.416 157.835 222.541 183.579 223.095 187.407C223.789 192.191 238.497 193.201 242.726 189.318C246.175 186.514 249.401 181.096 249.911 173.967C250.327 168.146 246.86 157.743 241.314 151.503C235.767 145.263 229.457 142.35 223.564 141.727Z",
    fill: "#141414"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M215.07 144.437C213.027 144.945 212.885 146.243 212.221 147.095C218.649 161.456 230.461 190.03 232.566 190.692C235.197 191.519 241.196 187.95 243.234 181.437C245.065 176.399 244.176 169.483 242.619 165.236C239.61 157.031 233.498 150.088 227.486 146.61C221.36 143.066 215.976 144.212 215.07 144.437Z",
    fill: "#D68585"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M213.613 145.12L204.68 150.605C204.597 158.431 205.821 175.531 211.381 181.326C218.331 188.57 224.351 190.185 229.588 191.017C234.825 191.849 238.137 188.189 239.126 187.003L239.154 186.969C240.558 185.285 244.135 180.997 242.99 170.964C240.281 158.464 232.345 151.197 226.827 147.654C221.938 144.515 216.051 144.483 213.613 145.12Z",
    fill: "#B45B5B"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M203.112 152.504L196.656 148.901L198.011 147.793L204.385 151.352L203.112 152.504Z",
    fill: "#FFC8C8"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M258.303 122.441L258.301 107.839L260.13 105.965L260.133 120.715L258.303 122.441Z",
    fill: "black"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M195.564 119.608C186.915 124.093 182.601 131.784 183.599 135.904C180.345 132.642 179.151 131.012 178.836 129.491C177.839 125.948 175.93 120.023 180.716 115.173C186.699 109.112 193.911 105.455 204.724 102.902C213.817 100.755 226.16 99.9365 237.885 101.527C247.416 102.82 255.914 105.77 258.302 107.528V122.298C254.932 121.204 251.676 119.58 235.932 116.195C220.187 112.811 205.779 114.31 195.564 119.608Z",
    fill: "black"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M209.411 149.034C200.526 149.538 200.202 159.601 200.79 164.676C201.797 170.256 204.559 174.368 207.733 178.191C217.825 189.82 227.113 187.929 229.213 186.833C231.435 185.672 236.823 180.742 235.338 172.443C234.197 166.066 228.728 159.285 226.36 156.879C223.951 154.431 217.654 148.567 209.411 149.034Z",
    fill: "#B45B5B"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M209.69 154.209C200.494 154.353 200.78 162.894 202.072 167.147C205.228 176.39 213.397 182.78 216.632 184.185C220.308 185.781 228.127 185.402 229.975 180.083C231.823 174.763 229.502 169.657 229.065 168.695C228.841 168.203 221.185 154.029 209.69 154.209Z",
    fill: "#D68585"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M265.079 113.239L258.623 109.636L259.978 108.527L266.352 112.087L265.079 113.239Z",
    fill: "#FFC8C8"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M258.809 119.854L258.623 109.637L265.001 113.203L264.103 122.816L258.809 119.854Z",
    fill: "#D07D7D"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M198.355 145.773L196.227 147.304C184.338 141.207 178.869 133.983 176.96 128.856C173.402 119.308 178.444 114.545 181.409 111.786C184.824 108.337 194.666 101.637 208.431 99.851C215.702 98.9077 221.496 98.3489 229.997 98.845C246.793 100.099 257.074 104.105 260.123 105.963L258.28 107.852C256.329 106.737 249.277 104.44 245.85 103.665C240.773 102.611 228.159 100.689 218.318 101.439C206.016 102.376 200.671 103.842 198.328 104.779C195.984 105.716 189.625 107.669 184.431 112.121C179.775 116.112 178.542 118.458 178.18 120.83C177.042 132.641 191.574 142.481 198.355 145.773Z",
    fill: "#FFC8C8"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M252.979 130.706C252.869 129.551 253.895 125.965 254.422 124.316L256.003 127.271L263.286 138.471C268.234 141.449 278.184 147.445 278.403 147.61C278.623 147.775 291.23 147.038 297.506 146.648C300.415 144.541 305.985 141.014 304.996 143.762C303.759 147.198 298.537 155.306 283.351 154.688C268.165 154.069 259.974 145.629 256.742 141.268C253.714 137.181 253.117 132.15 252.979 130.706Z",
    fill: "#B45B5B"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 281.069,
    cy: 129.383,
    rx: 28.4641,
    ry: 21.3281,
    transform: "rotate(22.8984 281.069 129.383)",
    fill: "#141414"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M262.883 142.712C263.001 141.932 263.465 140.186 264.373 139.449",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 281.599,
    cy: 125.832,
    rx: 13.3575,
    ry: 8.11767,
    transform: "rotate(22.8984 281.599 125.832)",
    fill: "#AB5050"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 282.927,
    cy: 127.67,
    rx: 11.4173,
    ry: 6.93854,
    transform: "rotate(22.8984 282.927 127.67)",
    fill: "#141414"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M278.209 137.302C288.365 141.592 298.712 140.066 301.319 133.894C303.926 127.722 297.806 119.241 287.65 114.951C277.494 110.661 267.147 112.187 264.54 118.359C261.933 124.531 268.053 133.012 278.209 137.302ZM280.229 132.52C286.038 134.974 291.956 134.101 293.447 130.571C294.938 127.041 291.438 122.19 285.629 119.737C279.82 117.283 273.903 118.156 272.412 121.686C270.921 125.216 274.421 130.067 280.229 132.52Z",
    fill: "#D68585"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M253.783 127.096C254.083 125.931 255.141 123.401 256.975 122.594",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M254.336 129.8C254.478 128.759 255.052 126.536 256.216 125.969",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M261.998 142.004C262.246 140.727 263.261 137.783 265.332 136.223",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M261.164 141.207C261.23 139.993 261.849 137.339 263.797 136.434",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M278.186 137.367C278.207 138.197 278.035 140.14 277.178 141.275",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M278.98 137.715C279.075 138.051 279.207 138.913 278.98 139.669",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M236.428 147.086C236.071 147.136 235.303 147.396 235.082 148.033",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M235.845 146.613C235.293 146.803 234.075 147.381 233.621 148.176",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M245.893 158.938C245.473 159.066 244.391 159.469 243.422 160.051",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M246.367 159.559C246.044 159.667 245.261 159.988 244.711 160.408",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M220.851 144.121C220.807 143.707 220.951 142.769 221.882 142.324",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M221.379 144.282C221.406 143.973 221.591 143.293 222.12 143.039",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M229.338 147.637C229.461 147.267 229.861 146.5 230.475 146.395",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M238.193 156.574C238.493 156.178 239.288 155.354 240.07 155.227",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M238.404 156.892C238.686 156.61 239.367 156.013 239.832 155.887",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M205.455 166.55L208.918 161.66L210.836 163.018C211.947 163.805 212.1 164.943 211.419 165.905C210.728 166.881 209.603 167.094 208.475 166.295L207.597 165.674L206.469 167.268L205.455 166.55ZM208.176 164.856L208.892 165.363C209.493 165.789 210.026 165.659 210.372 165.164C210.72 164.68 210.658 164.144 210.059 163.715L209.343 163.208L208.176 164.856Z",
    fill: "#EDAFAF"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M210.06 169.902C209.742 169.677 209.665 169.242 209.894 168.933C210.107 168.617 210.543 168.545 210.858 168.774C211.161 168.983 211.242 169.42 211.022 169.731C210.8 170.045 210.36 170.114 210.06 169.902Z",
    fill: "#EDAFAF"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M211.487 170.821L214.95 165.931L216.868 167.289C217.979 168.076 218.132 169.213 217.451 170.176C216.76 171.152 215.635 171.365 214.507 170.566L213.629 169.945L212.5 171.539L211.487 170.821ZM214.208 169.127L214.924 169.634C215.525 170.06 216.058 169.93 216.404 169.435C216.751 168.951 216.689 168.415 216.091 167.986L215.375 167.479L214.208 169.127Z",
    fill: "#EDAFAF"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M220.239 169.676L216.776 174.566L215.776 173.858L219.239 168.968L220.239 169.676Z",
    fill: "#EDAFAF"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M219.162 176.367C218.04 175.567 217.865 174.353 218.691 173.194C219.488 172.06 220.73 171.788 221.804 172.549C222.767 173.23 223.096 174.376 222.212 175.626L222.011 175.909L219.505 174.135C219.113 174.689 219.199 175.262 219.713 175.631C220.056 175.869 220.405 175.893 220.658 175.743L221.611 176.417C220.988 176.996 220.069 177.004 219.162 176.367ZM219.95 173.507L221.51 174.612C221.822 174.164 221.742 173.625 221.294 173.313C220.837 172.984 220.269 173.099 219.95 173.507Z",
    fill: "#EDAFAF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEtc03);
export default __webpack_public_path__ + "static/media/etc_03.2882e31115ec84f6e670c76e4c879e59.svg";
export { ForwardRef as ReactComponent };